import styled, { CSSProperties } from 'styled-components';
import {
  margin,
  MarginProps,
  rect,
  RectProps,
} from '../../../components/styles';

type Props = {
  notdot?: boolean;
  textAlign?: CSSProperties['textAlign'];
};

const Th = styled.th<RectProps>`
  font-size: ${({ theme }) => theme.fontSizes.s};
  font-weight: ${({ theme }) => theme.fontWeights.bold};
  color: ${({ theme }) => theme.fontColors.grey};
  padding: ${({ theme }) => `${theme.spaces.s} ${theme.spaces.m}`};
  border: 1px solid ${({ theme }) => theme.borderColors.default};
  ${rect}
`;

const Td = styled.td<Props>`
  padding: ${({ theme }) => `${theme.spaces.l} ${theme.spaces.l}`};
  border: 1px solid ${({ theme }) => theme.borderColors.default};
  background-color: ${({ theme }) => theme.backgroundColors.white};
  text-align: ${({ textAlign }) => textAlign};
`;

const Tr = styled.tr``;

const Tbody = styled.tbody``;

const Thead = styled.thead``;

const Root = styled.table<Props & MarginProps>`
  margin: 0;
  padding: 0;
  border-collapse: collapse;
  ${margin};
`;

export const Table = Object.assign(Root, { Thead, Tbody, Tr, Td, Th });
